var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainPage"},[_c('header',[_c('Menu')],1),_c('main',{staticClass:"viewContainer"},[_c('router-view')],1),_c('footer',[_c('LanguageSelector'),_c('img',{attrs:{"src":require("../assets/images/todust_email.png"),"alt":"To Dust email"}}),_c('Copyright')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }